import BaseComponent from "@js/components/base_component.jsx";

class EuiArchivedMessagesShow extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            q: {},
        };

        if ( props.q ) this.state.q = props.q;
    }

    render() {
        const msg = this.props.entity;

        return <div className="form-horizontal">
            <Panel heading="message_details">

                <InputField
                    object={this.props.entity}
                    type="archived_message"
                    field="time_injected_pretty_full"
                    editing={ false }
                />

                <InputField
                    object={this.props.entity}
                    type="archived_message"
                    field="rfc5321_mailfrom"
                    editing={ false }
                />

                <InputField
                    object={this.props.entity}
                    type="archived_message"
                    field="rfc5322_from"
                    editing={ false }
                />

                <InputField
                    object={this.props.entity}
                    type="archived_message"
                    field="recipients"
                    editing={ false }
                    multiline={ true }
                />

                <hr />

                <InputField
                    object={this.props.entity}
                    type="archived_message"
                    field="sendid"
                    editing={ false }
                />

                {
                    ( this.props.entity.injector === "simplemh" ) && <React.Fragment>
                        <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="mailclass"
                            editing={ false }
                        />

                        <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="instanceid"
                            editing={ false }
                        />

                        <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="listid"
                            editing={ false }
                        />

                        <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="clicktrackingid"
                            editing={ false }
                        />
                    </React.Fragment>
                }

                {
                    ( this.props.entity.injector === "studio" ) && <React.Fragment>
                        <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="studio_list_name"
                            editing={ false }
                        />

                        { this.props.entity.studio_campaign_name && <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="studio_campaign_name"
                            editing={ false }
                        /> }

                        { this.props.entity.studio_autoresponder_name && <InputField
                            object={this.props.entity}
                            type="archived_message"
                            field="studio_autoresponder_name"
                            editing={ false }
                        /> }
                    </React.Fragment>
                }

                <InputField
                    object={ msg }
                    type="archived_message"
                    field="mtaid"
                    editing={ false }
                    valueText={
                        ( msg.virtualmta_id && msg.virtualmta_name ) ? (
                            <a href={ Routes.eui_virtual_mta_entity_path({ id: msg.virtualmta_id }) }>{ msg.virtualmta_name }</a>
                        ) : (
                            msg.mtaid
                        )
                    }
                />

            </Panel>

            {
                this.props.entity.message_headers && this.props.entity.message_body ? (
                    <Panel heading="message_text">
                        <pre style={{ minHeight: "200px", maxHeight: "80vh", overflowY: "scroll" }}>{ this.props.entity.message_headers + "\n" + this.props.entity.message_body }</pre>
                    </Panel>
                ) : this.props.entity.message_headers ? (
                    <Panel heading="message_headers">
                        <pre style={{ minHeight: "200px", maxHeight: "80vh", overflowY: "scroll" }}>{ this.props.entity.message_headers }</pre>
                    </Panel>
                ) : (
                    null
                )
            }
        </div>;
    }

}

export default EuiArchivedMessagesShow;
